// ignore-string-externalization

import { useEffect } from 'react';
import { black, white } from '@spotify-internal/encore-web';
import { useLayoutContext } from '../Layout';

export function useProvidersLayoutContext() {
  const { setNavBarBackground, setNavBarTextColor, setNavBarBleed } =
    useLayoutContext();

  useEffect(() => {
    setNavBarBleed(true);
    setNavBarBackground(black);
    setNavBarTextColor(white);
  }, [setNavBarBackground, setNavBarTextColor, setNavBarBleed]);
}
